export const TEST_ID = {
  ICON: 'support-icon',
  POPOVER: 'support-popover',
  MODAL: 'support-modal'
};
